export default __webpack_public_path__ + "static/media/EG_Snappy-1.a75f44b7.wav";